import PropTypes from 'prop-types';
import GeneralLoader from '../../../loaders/GeneralLoader';
import { PUNCTUATION } from '../../../../utils/constants/notation';
import { FIELD_SOURCE, dataSourceClass } from '../../../../utils/constants/dataSources';

const IndustryCodeValue = ({ industryCode }) => {
  if (!industryCode) {
    return PUNCTUATION.EMPTY_VALUE;
  }
  // Without a name (tree not loaded yet, or a code it does not know) the code stands alone.
  if (!industryCode.name) {
    return industryCode.code;
  }

  const meta = industryCode.divisionName
    ? `${industryCode.code} · ${industryCode.divisionName}`
    : industryCode.code;

  return (
    <>
      <div>{industryCode.name}</div>
      <div className="industry-code-meta">{meta}</div>
    </>
  );
};

/**
 * SummaryIndustryCodeRow
 *
 * WZ 2008 code row for the General tab Summary card: the class name, then the
 * class code and its division name on a smaller second line. The code arrives
 * already resolved (`resolveIndustryCode`), so this row only lays it out.
 *
 * @param {Object} props
 * @param {Object|null} props.industryCode - `{ code, name, divisionName }`, null without a code
 * @param {boolean} props.isLoading - Whether the company data is still loading
 */
const SummaryIndustryCodeRow = ({ industryCode = null, isLoading = false }) => (
  <div className="card-row">
    <div className={`property ${dataSourceClass(FIELD_SOURCE.industryCode)}`}>WZ 2008 Code</div>
    <div className="value industry-code">
      {isLoading ? <GeneralLoader /> : <IndustryCodeValue industryCode={industryCode} />}
    </div>
  </div>
);

const industryCodeShape = PropTypes.shape({
  code: PropTypes.string.isRequired,
  name: PropTypes.string,
  divisionName: PropTypes.string
});

IndustryCodeValue.propTypes = {
  industryCode: industryCodeShape
};

SummaryIndustryCodeRow.propTypes = {
  industryCode: industryCodeShape,
  isLoading: PropTypes.bool
};

export default SummaryIndustryCodeRow;
